module.exports = __webpack_public_path__ + "web/img/icon5.56c8e333.png";